import { MyHttpClient } from '../../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import * as i0 from "@angular/core";
import * as i1 from "../../http-client.service";
var GuestOrderDetailsService = /** @class */ (function () {
    function GuestOrderDetailsService(http) {
        this.http = http;
        this.server = "" + environment.server;
    }
    GuestOrderDetailsService.prototype.getTripsBulk = function (ids, date) {
        var url = this.server + "/api/pool-manager/trips/bulk";
        var body = { ids: ids };
        if (date) {
            body.date = date;
        }
        return this.http.post(url, body).pipe(catchError(this.handleError));
    };
    GuestOrderDetailsService.prototype.getPoolTripsBulk = function (orderIds) {
        var url = this.server + "/api/pool-manager/pool/trips/bulk";
        var body = { orderIds: orderIds };
        return this.http.post(url, body).pipe(catchError(this.handleError));
    };
    GuestOrderDetailsService.prototype.handleError = function (error) {
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        }
        else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error("Backend returned code " + error.status + ", " +
                ("body was: " + error.error));
        }
        // return an observable with a user-facing error message
        return throwError(error);
    };
    GuestOrderDetailsService.ngInjectableDef = i0.defineInjectable({ factory: function GuestOrderDetailsService_Factory() { return new GuestOrderDetailsService(i0.inject(i1.MyHttpClient)); }, token: GuestOrderDetailsService, providedIn: "root" });
    return GuestOrderDetailsService;
}());
export { GuestOrderDetailsService };
